<template>
  <div>
    <el-table :data="records">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coinType" label="币种"> </el-table-column>
      <el-table-column prop="amount" label="利息总数"> </el-table-column>
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="lockAmount" label="存币金额"> </el-table-column>
      <el-table-column prop="inviteUserId" label="存币者"> </el-table-column>
      <el-table-column label="奖励类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">推荐人一级奖励</span>
          <span v-else-if="scope.row.type == 2">推荐人二级奖励</span>
          <span v-else-if="scope.row.type == 3">利息奖励</span>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未转账</span>
          <span v-else-if="scope.row.status == 1">转账成功</span>
          <span v-else
            >转账失败<i
              class="el-icon-position"
              @click="sendMoney(scope.row.id)"
            ></i
          ></span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'corocord',
  computed: {
    ...mapState('corocord', ['totalCount', 'pagination', 'rata', 'records'])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('corocord', ['getRecords', 'reSend']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    sendMoney(id) {
      this.$confirm('确定要重新转账吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.reSend({ interestId: id }).then(() => {
          this.$message.success('重发成功！');
          this.$emit('refresh');
        });
      });
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped></style>
